import { render } from "./BoschLogin.vue?vue&type=template&id=5788475c"
import script from "./BoschLogin.vue?vue&type=script&lang=js"
export * from "./BoschLogin.vue?vue&type=script&lang=js"

import "./BoschLogin.vue?vue&type=style&index=0&id=5788475c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__